import axios from "../../service/index"
import React, { Component } from "react"
import {Form, Input, Divider, message, Button} from 'antd'
import UploadQiniu from '../../commponents/uploadQiniu/index'
import BatchUploadQiniu from '../../commponents/batchUploadQiniu/index'
import Wangeditor from '../../commponents/wangeditor/index'
import "./openclass.less"
const FormItem = Form.Item;
class newSurface extends Component{
  constructor(props) {
		super(props)
    this.state = {
      modelTitle: '新建',
      userNameHead: '',
      images: [],
      clickUrl: '',
      courseUrl: '',
      qiuniuUrl: '',
      url: '',
      jobPositionId: '7',
      queryId: '',
      subjectId: '',
      content: '',
      isEdit: true,
      detailInfo: {},
      type: 0,
      qiniuVideo: '',
      isIntroduct: true,
      persistentId: '',
      isoutline: true,
      corporateName: '',
      jobPositionName: '',
      userName: '',
      studyVideo: null,
      introductionContent: '',
      outlineContent: '',
      researchTeamContent: '',
      studyExperienceContent: '',
    }
  }
  componentDidMount() {
    this.getToken()
    if(this.props.location.state?.id){
      this.setState({queryId: this.props.location.state.id, modelTitle: '编辑'}, () => {
        this.getInfo()
      })
    }
    this.setState({
      jobPositionId: this.props.location.state.jobPositionId, jobPositionName: this.props.location.state.jobPositionName
    })
  }
  handleOk = (e) => {
    e.preventDefault();
		this.props.form.validateFields((err, values) => {
			console.log(values)
			if (!err) {
        let params = {
          id: this.state.modelTitle === '编辑'?this.state.queryId:'',
          name: values.name,
          corporateName: values.corporateName,
          images: values.images,
          userName: values.userName,
          userNameHead: (values.userNameHead.url && this.state.modelTitle === '编辑')? values.userNameHead.url :this.state.qiuniuUrl+'/'+values.userNameHead.response.key,
          jobPositionId: this.state.jobPositionId||'',
          jobPositionName: this.state.jobPositionName||'',
          content: values.content||'',
        }
        let url = this.state.modelTitle === '新建'?'/interviewexperience/add': 'interviewexperience/update'
        axios.post(url, params).then(res => {
          if(res.data.code === '200'){
            message.success(this.state.modelTitle+'成功')
            this.props.form.resetFields()
            this.props.history.push('/mianJing', {id: this.state.jobPositionId, name: this.state.jobPositionName})
          }else{
            message.error(res.data.msg)
          }
        })
      }
    })
  }
  getInfo = () => {
    axios.get(`interviewexperience/info/${this.state.queryId}`).then(res => {
      if(res.data.code === '200'){
        let images = []
        if(res.data.data.images){
          images = res.data.data.images.map((v,i) =>  {return {...v, uid: i+res.data.data.name+Date.now()}} )
        }
        this.setState({
        //   type: res.data.data.type,
          detailInfo: res.data.data,
          content: res.data.data.content,
          images: images,
        userNameHead: {
            uid: null,
            type: null,
            url: res.data.data.userNameHead,
            name:res.data.data.name
          },
        }, () => {
          this.props.form.setFieldsValue({
            'content': res.data.data.content,
          })
        })
      }else{
        message.error(res.data.msg)
      }
    })
  }
  
  getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}
		}).catch((e) => {
		})
	}
  componentWillUnmount() {
    this.setState = () => false;
 }
  getQiniuUrl = (v) => {
    this.setState({
			qiuniuUrl: v
		})
  }
  getText = (v, i) => {
		this.props.form.setFieldsValue({
      'content': v
		});
	}
  render() {
    const {modelTitle, userNameHead, images, jobPositionName, content, detailInfo, jobPositionId} = this.state
    const { getFieldDecorator } = this.props.form;
    return (
        <div className="create-subject">
          <div className="header-between">
          <span className="header-name">{modelTitle}面经</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/mianJing', {id: jobPositionId, name: jobPositionName})
            }}>返回上一级</span>
          </div>
          <Divider />
          <Form labelCol={{ span: 3 }} wrapperCol={{ span: 12 }} onSubmit={this.handleOk}>
          <FormItem label={"岗位名称"}>
              {getFieldDecorator('name', {
                initialValue: detailInfo.name 
              })(
                <div>{jobPositionName}</div>
              )}
            </FormItem>
            <FormItem label={"面经标题"} key={0}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入面经标题!', }],
                initialValue:modelTitle==='编辑'? detailInfo.name: ''
              })(
                <Input placeholder='请输入面经标题' allowClear maxLength={50}/>
              )}
            </FormItem>
            <FormItem label="面经正文">
              {getFieldDecorator('content', {
                rules: [{ required: true, message: '请输入面经正文!', }],
                initialValue:modelTitle==='编辑'? content: ''
              })(
                  <Wangeditor content={content} getText={this.getText} style={{zIndex: '99'}} />
              )}
            </FormItem>
            <FormItem label={"公司名称"}>
              {getFieldDecorator('corporateName', {
                rules: [{ required: true, message: '请输入公司名称!', }],
                initialValue:modelTitle==='编辑'? detailInfo.corporateName: ''
              })(
                <Input placeholder='请输入招聘公司名称' allowClear maxLength={50}/>
              )}
            </FormItem>
            <Form.Item label="面经配图" className="posterUrl" key={6}>
              {getFieldDecorator('images', {
                initialValue: modelTitle==='编辑'? images: '',
                // rules: [{ required: true, message: '请上传面经配图!' }],
              })(
                  // <UploadQiniu limit={8} getQiniuUrl ={this.getQiniuUrl } />
                  <BatchUploadQiniu limit={8} className="upload-img"  />
              )}
            </Form.Item>
            <FormItem label={"虚拟发布人"}>
              {getFieldDecorator('userName', {
                rules: [{ required: true, message: '请输入发布人昵称!', }],
                initialValue:modelTitle==='编辑'? detailInfo.userName: ''
              })(
                <Input placeholder='请输入发布人昵称' allowClear maxLength={20}/>
              )}
            </FormItem>
            <Form.Item label="虚拟发布人头像" className="posterUrl">
              {getFieldDecorator('userNameHead', {
                initialValue: modelTitle==='编辑'? userNameHead: '',
                rules: [{ required: true, message: '请上传虚拟发布人头像!' }],
              })(
                  <UploadQiniu getQiniuUrl={this.getQiniuUrl } />
              )}
            </Form.Item>
            
            
            <FormItem>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<Button style={{ marginRight: '30px' }} onClick={() => {
								this.props.history.push('/mianJing', {id: jobPositionId, name: jobPositionName})
							}}>取消</Button>
							<Button type="primary" htmlType="submit">确定</Button>
						</div>
            </FormItem>
          </Form>
        </div>
    )
  }
}
export default Form.create()(newSurface)